import { httpClient } from "../http/httpClient"

export type ProductImageVariant = 'image' | 'imageBlack'

export async function uploadProductImage(
  type: string,
  image: File,
  variant: ProductImageVariant = 'image',
) {
  const formData = new FormData()
  formData.append('image', image)

  const { data } = await httpClient.patch<{ success: boolean }>(
    `/config/product/${type}/image`,
    formData,
    {
      headers: { 'Content-Type': 'multipart/form-data' },
      params: { variant },
    },
  )
  return data
}